import React from 'react';
import { Button } from '../../../ui/Button';
import { Wand2 } from 'lucide-react';
import { usePropertyFormContext } from '../contexts/PropertyFormContext';
import { generateShowcaseText } from './Description/utils/textGenerator';

interface DescriptionProps {
  onNext: () => void;
}

export const Description: React.FC<DescriptionProps> = ({ onNext }) => {
  const { formData, handleInputChange } = usePropertyFormContext();

  const handleGenerateShowcaseText = () => {
    const showcaseText = generateShowcaseText(formData.advertisingText || '');
    handleInputChange({
      target: {
        name: 'showcaseText',
        value: showcaseText,
        type: 'textarea'
      }
    } as React.ChangeEvent<HTMLTextAreaElement>);
  };

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
          Titre Annonce
        </label>
        <input
          type="text"
          name="advertisingTitle"
          value={formData.advertisingTitle || ''}
          onChange={handleInputChange}
          className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
          placeholder="Titre accrocheur pour votre annonce..."
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
          Texte Publicité
        </label>
        <textarea
          name="advertisingText"
          value={formData.advertisingText || ''}
          onChange={handleInputChange}
          rows={8}
          className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
          placeholder="Rédigez ici votre texte publicitaire détaillé..."
        />
      </div>

      <div className="flex justify-end">
        <Button
          onClick={handleGenerateShowcaseText}
          className="flex items-center gap-2"
          disabled={!formData.advertisingText}
        >
          <Wand2 className="h-4 w-4" />
          Générer le texte vitrine
        </Button>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
          Texte Vitrine
        </label>
        <textarea
          name="showcaseText"
          value={formData.showcaseText || ''}
          onChange={handleInputChange}
          rows={4}
          className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
          placeholder="Version courte pour l'affichage en vitrine..."
        />
        <p className="mt-2 text-sm text-gray-500">
          {formData.showcaseText?.length || 0} caractères
        </p>
      </div>

      <div className="flex justify-end">
        <Button onClick={onNext}>
          Suivant
        </Button>
      </div>
    </div>
  );
};